import {
  PlaneGeometry,
  Shape,
  ShapeGeometry,
  Vector3,
  SRGBColorSpace,
  LinearSRGBColorSpace,
} from "three";
import { Text } from "troika-three-text";

let VUtil = {
  /**
   * 创建圆角矩形几何体
   * @param {*} width 宽度
   * @param {*} height 高度
   * @param {*} radius 圆角半径
   * @returns
   */
  createRectangleGeometry(width, height, radius = 0.1) {
    if (radius <= 0) {
      return new PlaneGeometry(width, height);
    }

    var shape = new Shape();
    shape.moveTo(0, radius);
    shape.lineTo(0, height - radius);
    shape.quadraticCurveTo(0, height, radius, height);
    shape.lineTo(width - radius, height);
    shape.quadraticCurveTo(width, height, width, height - radius);
    shape.lineTo(width, radius);
    shape.quadraticCurveTo(width, 0, width - radius, 0);
    shape.lineTo(radius, 0);
    shape.quadraticCurveTo(0, 0, 0, radius);

    var geometry = new ShapeGeometry(shape);

    // 计算 UV 坐标
    var uv = geometry.attributes.uv;

    for (var i = 0; i < uv.count; i++) {
      uv.setXY(i, uv.getX(i) / width, uv.getY(i) / height);
    }

    geometry.translate(-width / 2, -height / 2, 0);
    return geometry;
  },

  /**
   * 生成简单的id
   * @returns
   */
  generateSimpleId() {
    const str = Date.now() + Math.random().toString(36).substring(2, 9);
    let result = "";
    for (let i = 0; i < str.length; i++) {
      result += str[i];
      // 每隔 8 个字符插入一个 "-"，且确保不是最后一个字符
      if ((i + 1) % 8 === 0 && i !== str.length - 1) {
        result += "-";
      }
    }
    return result;
  },

  /**
   * 创建3D文字
   * @param {*} message
   * @param {*} height
   * @param {*} color
   * @param {*} font
   * @param {*} cb
   * @param {*} outlineWidth
   * @param {*} align "center"/"left"/"right"
   * @returns
   */
  createText(
    message,
    height,
    color = "#ffffff",
    font = "normal",
    cb,
    outlineWidth = 0.001,
    outlineColor,
    align = "center"
  ) {
    // 如果要修改Text的shader，需要修改Text.material.baseMaterial，这个属性就是MeshBasicMaterial，修改Text.material无效
    const myText = new Text();
    // Set properties to configure:
    myText.font = "/assets/HONORSansCN-Light.ttf";
    myText.text = message;
    myText.fontSize = height;
    myText.color = color;
    if (font === "bold") {
      myText.outlineWidth = outlineWidth;
      myText.outlineColor = color;
    }
    if (outlineColor) {
      myText.outlineWidth = outlineWidth;
      myText.outlineColor = outlineColor;
    }

    myText.textAlign = "left";
    if (Array.isArray(myText.material)) {
      myText.material.forEach((element) => {
        element.transparent = true;
        element.color.convertSRGBToLinear();
        this.convertSRGBToLinear(element);
      });
      myText.material[1].baseMaterial.depthTest = false;
      myText._baseMaterial = myText.material[1].baseMaterial;
    } else {
      myText.material.baseMaterial.depthTest = false;
      myText._baseMaterial = myText.material.baseMaterial;
      //myText.material.transparent = true;
      myText.material.color.convertSRGBToLinear();
      this.convertSRGBToLinear(myText.material);
    }

    //回调事件，当异步更新完成后会调用
    myText.sync(() => {
      let size = myText.geometry.boundingBox.getSize(new Vector3());
      myText._width = size.x;
      myText._height = size.y;
      if (align === "center") myText.position.x -= size.x / 2;
      if (align === "right") myText.position.x -= size.x;
      myText.position.y += size.y / 2;

      myText.position.z += 0.001;
      if (cb) cb(myText);
    });

    return myText;
  },

  /**
   * 将颜色从 sRGB 转换为线性空间
   * @param {*} mat
   */
  convertSRGBToLinear(mat) {
    //mat.color.convertSRGBToLinear(); //
  },

  setTextColor(text, color) {
    text.color = color;
    text.sync();
  },
};

export default VUtil;
